// 商城奖励接口
import request from '@/utils/http.js';

// 观看端-获取当前直播有效商城奖励列表
const getValidList = params => {
  return request('/v3/vss/mall-reward/get-valid-list', {
    method: 'POST',
    data: params
  });
}

// 观看端-领取商城奖励
const receive = params => {
  return request('/v3/vss/mall-reward/receive', {
    method: 'POST',
    data: params
  });
}

export default {
  getValidList,
  receive
}